"use client";

import Image from "next/image";
import Link from "next/link";
import { useState, useEffect, useMemo } from "react";
import Loader from "../Loader";
import styles from "./Category.module.css";

type Category = {
  id: string;
  name: string;
  image?: string;
  createdAt?: string;
  brand?: {
    name: string;
    image?: string;
  };
};

type ShopCategoryProps = {
  spacing?: string;
  categories?: Category[];
};

const ShopCategory = ({
  spacing = "80px 0",
  categories = [],
}: ShopCategoryProps) => {
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    console.log("SHOP CATEGORY DATA:", categories);
  }, [categories]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sortedCategories = useMemo(() => {
    return [...categories].sort(
      (a, b) =>
        new Date(a.createdAt || "").getTime() -
        new Date(b.createdAt || "").getTime()
    );
  }, [categories]);

  if (!sortedCategories || sortedCategories.length === 0) return null;

  return (
    <>
      {loading && <Loader />}

      <section
        style={{
          padding: isMobile ? "20px 0 40px" : spacing,
          background: "#ffffff",
        }}
      >
        <div
          style={{
            maxWidth: "1440px",
            margin: "0 auto",
            padding: isMobile ? "0 14px" : "0 60px",
          }}
        >
          {/* HEADER */}
          <p className={styles.catSectionLabel}>PRODUCT CATEGORIES</p>
          <div className={styles.catHeader}>
            <div className={styles.catHeaderInner}>
              <h2 className={styles.catHeaderTitle}>TOP CATEGORIES</h2>
              <div className={styles.catUnderline} />
            </div>
          </div>

          {/* GRID */}
          <div className={styles.catGrid}>
            {sortedCategories.map((item) => (
              <Link
                key={item.id}
                href={`/shop?category=${item.id}`}
                onClick={() => setLoading(true)}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div className={styles.catCard}>

                  {/* BRAND BADGE */}
                  {item?.brand?.name && (
                    <span className={styles.brandBadge}>
                      {item.brand.image && (
                        <img
                          src={item.brand.image}
                          alt={item.brand.name}
                          className={styles.badgeLogo}
                        />
                      )}
                      {item.brand.name}
                    </span>
                  )}

                  {/* IMAGE */}
                  <div className={styles.catImgWrap}>
                    {item.image && (
                      <Image
                        src={item.image}
                        alt={item.name}
                        fill
                        className={styles.catImg}
                      />
                    )}
                  </div>

                  {/* CATEGORY NAME */}
                  <div className={styles.catBottom}>
                    <p className={styles.catName}>{item.name}</p>
                  </div>

                </div>
              </Link>
            ))}
          </div>

          {/* CTA */}
          <div className={styles.ctaWrap}>
            <Link href="/shop" className={styles.ctaBtn} onClick={() => setLoading(true)}>
              View All Products
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
          </div>

        </div>
      </section>
    </>
  );
};

export default ShopCategory;